// Client-side helper for /api/scrape-listing.

export async function scrapeListing(url) {
  if (!url?.trim()) throw new Error('paste a listing URL');
  // Client-side timeout — the server has its own 12s upstream timeout, so
  // 18s here leaves enough slack for the response round-trip.
  const ac = new AbortController();
  const timer = setTimeout(() => ac.abort(), 18000);
  try {
    const res = await fetch('/api/scrape-listing', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ url: url.trim() }),
      signal: ac.signal,
    });
    if (!res.ok) {
      if (res.status === 404) throw new Error('endpoint not available — run `wrangler pages dev` instead of `vite dev`');
      let msg;
      try { msg = (await res.json()).error; } catch { msg = await res.text(); }
      throw new Error(msg?.slice(0, 200) || `scrape failed (${res.status})`);
    }
    return await res.json();
  } catch (err) {
    if (err.name === 'AbortError') throw new Error('fetch timed out — paste address manually');
    throw err;
  } finally {
    clearTimeout(timer);
  }
}
